export default "__VITE_ASSET__xfHYZoWz__"